/** Deutsche Flagge als SVG (Emoji-Flaggen werden unter Windows nur als "DE" dargestellt). */
export function GermanFlag({ className = "h-6 w-9" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 5 3"
      className={`${className} rounded-[3px] shadow-[0_0_0_1px_rgba(255,255,255,0.18),0_2px_8px_rgba(0,0,0,0.5)]`}
      role="img"
      aria-label="Deutsche Flagge"
    >
      <rect width="5" height="1" y="0" fill="#000000" />
      <rect width="5" height="1" y="1" fill="#dd0000" />
      <rect width="5" height="1" y="2" fill="#ffce00" />
    </svg>
  );
}
